import styled from 'styled-components';

export const Container = styled.figure`
    width: 100%;
    height: 60vh;
    display: flex;
    padding-top: 50px;
    padding-bottom: 100px;
    justify-content: space-evenly;
    align-items: center;

    figure {
        width: 400px;
        img {
            width: 300px;
        }
    }

    section {
        width: 400px;

        h1 {
            font-family: Arial, Helvetica, sans-serif;
            font-size: 40px;
            font-weight: 600;
        }

        p {
            margin-top: 10px;
            font-family: Arial, Helvetica, sans-serif;
            font-size: 24px;
        }
        
        a {             
            transition: 0.3s ease;
            color: var(--white);
            
            &:hover {
                color: var(--strong-pink);
            }
            
            button {
                cursor: pointer;       
                border: 0;
                background: var(--strong-pink);
                color: var(--white);
                margin-top: 50px;
                padding: 5px 25px;
                font-size: 24px;
                border-radius: 50px;
                border: 1px solid transparent;
                transition: 0.3s ease;

                &:hover {
                    background: var(--white);
                    border: 1px solid var(--strong-pink);
                    color: var(--strong-pink);
                }   
            }   
        }

    }
`;